import { CrossNavigation, LogoType } from '@ankr.com/cross-navigation';

import { useGlobalMenuStyles } from 'modules/globalMenu/components/useGlobalMenuStyles';
import { featureConfig } from 'modules/common/featureConfig';

interface IGlobalMenuWrapperProps {
  className?: string;
}

export const GlobalMenuWrapper = ({ className }: IGlobalMenuWrapperProps) => {
  const { classes: globalMenuClasses } = useGlobalMenuStyles();

  return (
    <CrossNavigation
      classes={{
        root: className,
        logo: globalMenuClasses.globalMenuLogo,
      }}
      logoType={
        featureConfig.isBlockrailTheme ? LogoType.BLOCKRAIL : LogoType.Web3API
      }
      isNavMenuHidden
    />
  );
};
